import { defineStore } from "pinia"
import { v4 as uuidv4 } from "uuid"
import type { BNotif } from "~/utils/models"

interface NotifStoreInterface {
  showNotifSideModal: boolean // whether sidebar modal overlay is shown
  notifications: BNotif[]
}

export const useNotifStore = defineStore("notif", {
  state: () =>
    ({
      notifications: [],
      showNotifSideModal: false,
    }) as NotifStoreInterface,
  actions: {
    addNotification<T>(
      notification: Pick<BNotif<T>, "title" | "text" | "level"> &
        Partial<Omit<BNotif<T>, "title" | "text" | "level">>,
    ) {
      const defaultValues = {
        uuid: uuidv4() as string,
        createdAt: new Date(),
        isActive: true,
        ttl: 3000,
        isRead: false,
        actions: undefined,
        icon: "",
        data: undefined,
      }
      this.notifications.push({ ...defaultValues, ...notification })
    },
    toggleNotifIsRead(notification_uuid: string) {
      const idx = this.notifications.findIndex((o) => o.uuid === notification_uuid)
      if (idx !== -1) {
        this.notifications[idx].isRead = !this.notifications[idx].isRead
      }
    },
    deleteAllNotifications() {
      this.notifications = []
    },
  },
})
